// extracted by mini-css-extract-plugin
export var equalColumn = "_hp-0";